export class Language {

  private _completeName: String;
  get completeName(): String {
    return this._completeName;
  }
  set completeName(name: String) {
    this._completeName = name;
  }

  private _flagClass: String;
  get flagClass(): String {
    return this._flagClass;
  }
  set flagClass(flag: String) {
    this._flagClass = flag;
  }

  constructor(completeName: String, flagClass: String) {
    this._completeName = completeName;
    this._flagClass = flagClass;
  }
}
